'use strict';

var React = require('react');

var PropTypes = require('prop-types');

module.exports = function render(props) {
  var innerHtml = '<g id="Group_2_Copy1-Page-Update-Specs-20516" fill="none" fill-rule="evenodd"><g id="Group_2_Copy1-01.-Icons/22x22/account/address_book-Copy-5-20516" fill="#585B58" transform="translate(0 1.455)"><path d="M15.273 0c.401 0 .727.326.727.727v11.637a.727.727 0 0 1-.727.727H.727A.727.727 0 0 1 0 12.364V.727C0 .326.326 0 .727 0h14.546zM5.09 4.765a.727.727 0 0 0-.546.246l-3.09 3.6v3.025h13.09V8.727l-1.672-1.665a.727.727 0 0 0-1.026 0l-1.84 1.833a.727.727 0 0 1-1.069-.044L5.636 5.01a.727.727 0 0 0-.545-.246zm6.182-1.856a1.09 1.09 0 1 0 0 2.182 1.09 1.09 0 0 0 0-2.182z" id="Group_2_Copy1-&#x21B3;-&#x1F3A8;-Fill-color-20516"/></g></g><!-- Filename: sourceSvg/photos/photos_selected.svg -->';
  var svgProps = {
    className: props.className ? props.className + ' uig-svg-icon' : 'uig-svg-icon',
    dangerouslySetInnerHTML: {
      __html: innerHtml
    },
    viewBox: '0 0 16 16'
  };
  return React.createElement('svg', Object.assign({}, props, svgProps));
};